var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#1557bf",
    d: "M11.766.845L6.57 6.043 6.25 7.068l1.025-.318 5.198-5.197-.708-.708z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M5.986 4.105l2.397 2.397"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1557bf",
    d: "M5.997 1.223H1.495v10.963h11.012V7.71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconActive);
export default __webpack_public_path__ + "static/media/edit-icon-active.fca4b23352fed7421245d953b96edcf0.svg";
export { ForwardRef as ReactComponent };